export class ParticipantsQuizAttemptsFilter {
    userName: string;
    firstName: string;
    lastName: string;
    type : string;    
    promotionId : string;
    quizId : string;
}